import { createActionBundle } from 'utilities/request';

export const {
  fetch: redcapDictionary,
  request: requestRedcapDictionary,
  success: requestRedcapDictionarySuccess,
  failure: requestRedcapDictionaryFailure,
} = createActionBundle('REDCAP/DICTIONARY');

export const {
  request: updateRedcapDictionary,
  success: updateRedcapDictionarySuccess,
  failure: updateRedcapDictionaryFailure,
} = createActionBundle('UPDATE/DICTIONARY');
